import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { handleLogout } from "../../mainApiRoutes/login";

const options = ["LOGOUT", "PORTAL"];

function HeaderButtonDropdown() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleLogoutClicked = async () => {
    await handleLogout();
    window.location.href = "/portal-login";
  };

  const handlePortalClicked = () => {
    window.location.href = "/portal-login";
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <div className="button-dropdown">
      <React.Fragment>
        <ButtonGroup
          // variant="contained"
          ref={anchorRef}
          aria-label="Button group with a nested menu"
          sx={{
            // backgroundColor: "#1c46b4",
            width: "100%",
          }}
        >
          <Button
            onClick={handlePortalClicked}
            sx={{
              color: "white",
              padding: "15px",
              borderRadius: "50px",
              backgroundColor: "#1c46b4",
              fontWeight: "800",
              textAlign: "center",
            }}
          >
            {options[selectedIndex]}
          </Button>
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
            sx={{
              color: "white",
              padding: "15px",
              borderRadius: "50px",
              backgroundColor: "#1c46b4",
            }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{ zIndex: 1 }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {options
                      .filter((val) => val !== "PORTAL")
                      .map((option, index) => (
                        <MenuItem
                          key={option}
                          disabled={index === 2}
                          selected={index === selectedIndex}
                          onClick={handleLogoutClicked}
                        >
                          {option}
                        </MenuItem>
                      ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    </div>
  );
}

export default HeaderButtonDropdown;
